// extracted by mini-css-extract-plugin
export default {"navigationContainer":"LowerNavigation_navigationContainer__N+8Tn","dropdownHeader":"LowerNavigation_dropdownHeader__PhsGJ"};